export const SET_GUIDE = "SET_GUIDE"
export const SET_ROOM = "SET_ROOM"
export const SHOW_EMBASSY = "SHOW_EMBASSY"
export const RESET_ROOMS_HISTORY = "RESET_ROOMS_HISTORY"
export const SHOW_CONTENT = "SHOW_CONTENT"
export const HIDE_CONTENT = "HIDE_CONTENT"
export const SET_HOTSPOT = "SET_HOTSPOT"
export const SHOW_HELP = "SHOW_HELP"
export const HIDE_HELP = "HIDE_HELP"